<template>
  <div class="index">
    <h1 class="h1 title">{{$t('contact.title')}}</h1>
    <div class="lead white-space-pre-wrap">{{$t('contact.lead')}}</div>
    <div class="note white-space-pre-wrap">
      <p>サポート対応時間　<br class="sp">10:00 ～ 19:00（土日・祝日は除く）</p>
      <p>※お問合せはメールにて24時間お受けしておりますが、返信は営業時間内とさせていただいております。</p>
      <p>※土・日・祝日・年末年始のお問合せは翌営業日以降の返信となります。</p>
    </div>
    
    <!-- <div class="text-left check">
      <div class="custom-control custom-checkbox">
        <input class="custom-control-input" type="checkbox" id="custom-check-1" @click="app_user(!use_app)" :checked="use_app ? 'checked' : '' "/>
        <label class="custom-control-label" for="custom-check-1">{{$t('contact.caption1')}}</label>
      </div>
    </div> -->
    <form @submit.prevent="submitContactInfo">
      <div class="form-group text-left">


        <label v-html="$t('contact.name')"></label>
        <input v-bind:class="{'input-red' : errors.has('name')}" type="text" v-validate="validateTextFullSize(form.name, true)" v-model="form.name" name="name" :placeholder="$t('contact.name_place')"/><span class="text-red" v-show="errors.has('name')">{{ errors.first('name') }}</span>


        <div class="flex">
          <label v-html="$t('contact.mail')"></label>
        </div>
        <input v-bind:class="{'input-red' : errors.has('email')}" type="text" v-validate="validateTextFullSize(form.email, true, ['email_strict'])" v-model="form.email" name="email" :placeholder="$t('contact.mail_place')" autocapitalize="off"/><span class="text-red" v-show="errors.has('email')">{{ errors.first('email') }}</span>






        <div v-if="this.$route.query.user_id" class="app_user">
          <label v-html="$t('contact.user_id')"></label>
          <input class="app-form-user user-id" type="text" v-model="form.user_id"  name="user_id" disabled/>
        </div>


        <div v-if="this.$route.query.user_name" class="app_user">
          <label v-html="$t('contact.user')"></label>
          <input class="app-form-user" type="text" v-model="form.user_name" name="user_name" disabled/>
        </div>






        <label v-html="$t('contact.detail')"></label>
        <textarea v-bind:class="{'input-red' : errors.has('detail')}" v-validate="validateTextFullSize(form.detail, true)" v-model="form.detail" rows="5" name="detail" :placeholder="$t('contact.detail_place')"></textarea><span class="text-red" v-show="errors.has('detail')">{{ errors.first('detail') }}</span>


        <div class="btn-wrapper text-center">
          <button class="btn btn-red position-relative" type="submit">{{$t('contact.submit')}}<span class="arrows arrows-right arrows-first border-white ml-7"></span></button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import { META_CONTACT } from '@/mixins/metadata.js'
  import CONTACT_FORM from '@/mixins/contactForm.js'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    mixins: [META_CONTACT, CONTACT_FORM],
    name: 'ContactForm',
    data() {
      return {
        form: {
          organization_name: null,
          name: null,
          email: '',
          title: null,
          detail: null,
          user_id:null,
          user_name:null,
        },
        date_now: this.$moment().format(),
        end_date: this.$moment('2020-12-30T11:59:59+09:00').format(),
        isApp:false,
        // use_app: false,
      }
    },
    head: {
      title: {
        inner: 'お問い合わせ｜ZATSUDAN'
      },
      meta: [
        { name: 'keywords', content: 'お問い合わせ' },
        { name: 'description', content: 'wakumoへのお問い合わせはこちら' },
      ]
    },
    watch: {
      isDisabled(value) {
        if (value) {
          this.form.detail = null
        }
      }
    },

    computed: {
      // ...mapState('contact', ['use_app']),
      ...mapGetters('contact', ['use_app']),
      isDisabled() {
        return this.form.tmpInquiry !== 'other'
      },
      contactDataStored() {
        const data = localStorage.getItem('contactData')
        return JSON.parse(data)
      },
      tmpInquiry() {
        return this.form.tmpInquiry
      }
    },

    created() {
      this.updateFormData(this.contactDataStored)
    },

    mounted() {
      this.$nextTick(() => {
        if (this.contactDataStored) {
          this.updateFormData(this.contactDataStored)
        }
        setTimeout(() => {
          this.$validator.reset()
        }, 100)
      })
    },

    methods: {
      ...mapActions('contact', ['app_user']),
      getInquiryTitle(key) {
        const result = _.find(this.INQUIRY, { id: key })
        return result.title
      },

      saveToLocalStorage() {
        const newData = _.omit(this.form, ['agreed'])
        const contactDataJson = JSON.stringify(newData)
        localStorage.setItem('contactData', contactDataJson)
      },

      updateFormData(data) {
        this.form = _.assign(this.form, data)
        this.form.user_id = this.$route.query.user_id
        this.form.user_name = this.$route.query.user_name
      },

      submitContactInfo() {
        this.$validator.validate().then((valid) => {
          if (valid) {
            this.saveToLocalStorage()
            this.$nextTick(() => {
              this.$router.push({ name: 'contact.confirm' })
            })
          }
        })
      },
      // app_user() {
      //   this.use_app = !this.use_app
      //   console.log(this.use_app)
      // },
      isAfter(dateNow, endDate) {
        return this.$route.query.time ? this.$moment(this.$route.query.time).isAfter(endDate) : this.$moment(dateNow).isAfter(endDate)
      }
    }
  }
</script>
